import { api } from '@api'
import type { SetupFilter } from '../filter'
import type { Pagination } from '../index'
import { applyFilters } from '../utils/applyFilters'

export const handleGetSubscribed = async ({
  filters,
  userId,
  pagination,
}: { filters: SetupFilter; userId: string; pagination: Pagination }) => {
  const { data: subscribedRows } = await api().rpc('get_user_subscribed_setups', { p_user_id: userId })

  const setupIds = (subscribedRows || []).map((row: { id: string }) => row.id)
  if (setupIds.length === 0) return []

  let query = api().from('setup_enriched').select('*').in('id', setupIds)

  query = applyFilters(query, filters)

  if (pagination.limit !== undefined && pagination.offset !== undefined) {
    query = query.range(pagination.offset, pagination.offset + pagination.limit - 1)
  }

  const { data } = await query
  return data || []
}
